import React from "react";
import PropTypes from "prop-types";
import styles from "./CheckItem.module.css";
import RadialBtn from "assets/RadialBtn.svg";
import RadialBtnChecked from "assets/RadialBtnChecked.svg";

export function CheckItem({ itemTitle, isChecked, onClick }) {
  return (
    <div className={styles.container} onClick={() => onClick(itemTitle)}>
      <img
        src={isChecked ? RadialBtnChecked : RadialBtn}
        alt={isChecked ? "checked" : "unchecked"}
        className={styles.radial}
      />
      <div className={styles.itemTitle}>{itemTitle}</div>
    </div>
  );
}

CheckItem.propTypes = {
  itemTitle: PropTypes.string,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
};